<div class="container">


    <!-- <div class="header">
        <div></div>
        <img src="/assets/images/logo-header-dark.svg" alt="">
        <div>
            <div>
                Dashboard Comité 
                <svg style="height: 30px; width: auto;" xmlns="http://www.w3.org/2000/svg" width="86.366" height="46.194" viewBox="0 0 86.366 46.194"><defs><style>.a{fill:#5e5e5e;}</style></defs><path class="a" d="M70.215,27.343a4.744,4.744,0,0,0,3.664.055v-.753a2.808,2.808,0,0,0-2.855-2.838h-3.95a7.561,7.561,0,0,0,3.14,3.536Zm0,0" transform="translate(-54.501 -19.414)"/><path class="a" d="M45.465,25.862a13.32,13.32,0,0,1-.9-1.882,2.936,2.936,0,0,0-2.19,2.806v.6a3.944,3.944,0,0,0,3.09-1.522Zm0,0" transform="translate(-34.432 -19.556)"/><path class="a" d="M48.092,55.465a5.723,5.723,0,0,0,5.717-5.713v-3.72a7.142,7.142,0,0,1-1.825.235,6.415,6.415,0,0,1-2.8-.635,7.723,7.723,0,0,1-2.353-1.77,6.339,6.339,0,0,1-4.453,1.926v3.963a5.723,5.723,0,0,0,5.717,5.713Zm0,0" transform="translate(-34.432 -35.711)"/><path class="a" d="M360.409,25.832c3.114.474,5.128.641,6.132-1.784a3.76,3.76,0,0,0-1.256-1.59,3.939,3.939,0,0,0-3.335-.642l-3.817.99a1.119,1.119,0,0,1-.283.029h-1.361a1.123,1.123,0,0,0-1.114,1.1v2.017c1.5-.661,3.446-.367,5.033-.125Zm0,0" transform="translate(-288.761 -17.693)"/><path class="a" d="M360.274,52.487c-3.284-.5-4.257-.4-4.661,1.281l.032,2.589.586.446a1.03,1.03,0,0,0,.614.209h1.361a1.022,1.022,0,0,0,.75-.333,3.263,3.263,0,0,1,4.814-.008l0,.008a1.023,1.023,0,0,0,.75.333h1.362a1.022,1.022,0,0,0,.614-.21l.581-.443-.048-4.606C365.078,53.216,362.4,52.811,360.274,52.487Zm0,0" transform="translate(-288.955 -42.123)"/><path class="a" d="M364.805,85.759a3.277,3.277,0,0,1-2.4-1.057l-.005-.01a1.016,1.016,0,0,0-1.5,0,3.28,3.28,0,0,1-2.41,1.064h-1.362a3.27,3.27,0,0,1-1.168-.223l.032,2.678,5.662,3.706,5.765-3.7-.028-2.7a3.3,3.3,0,0,1-1.222.244Zm0,0" transform="translate(-289.234 -68.62)"/><path class="a" d="M204.119,49.388V45.682l.024-.889a5.006,5.006,0,0,0-2.193-4.289,4.444,4.444,0,0,0-1.087-.543A18.867,18.867,0,0,1,188.374,48.7v.8a7.819,7.819,0,0,0,2.3,5.612,7.733,7.733,0,0,0,5.6,2.295,7.982,7.982,0,0,0,7.844-8.021Zm0,0" transform="translate(-153.063 -32.541)"/><path class="a" d="M168.8,19.771a10.245,10.245,0,0,1-.262-2.435V15.75A1.323,1.323,0,0,1,169.8,14.4,16.111,16.111,0,0,0,181.7,5.975a1.123,1.123,0,0,1,1.14-.575,6.568,6.568,0,0,1,2.755,1.065,7.255,7.255,0,0,1,3.208,6.194l-.017.874v3.69a10.308,10.308,0,0,1-.232,2.187,16.4,16.4,0,0,0,1.1-2.141,11.293,11.293,0,0,0,.173-8.635c-1.114-2.762-2.867-2.5-3.206-2.419a1.124,1.124,0,0,1-1.327-.739l-.049-.146a8.117,8.117,0,0,0-3.766-4.13A7.834,7.834,0,0,0,175.652.72a12.4,12.4,0,0,0-7.723,6.249,11.779,11.779,0,0,0-1.183,5.732,15.645,15.645,0,0,0,2.056,7.071Zm0,0" transform="translate(-135.479 -0.375)"/><path class="a" d="M212.375,141.925v2.23a3.374,3.374,0,1,0,6.748,0V141.91a10.419,10.419,0,0,1-3.305.588h-.082a10.319,10.319,0,0,1-3.361-.573Zm0,0" transform="translate(-172.566 -115.379)"/><path class="a" d="M66.064,164.258l2.1-1.9-1.347-7.439H65.275L64.1,162.37Zm0,0" transform="translate(-52.086 -125.949)"/><path class="a" d="M361.191,150.4l2.9-1.173-2.4-3.419h-.184Zm0,0" transform="translate(-293.486 -118.548)"/><path class="a" d="M70.168,135.5l.419-1.687H68.273l.419,1.687Zm0,0" transform="translate(-55.476 -108.797)"/><path class="a" d="M398.431,145.809h-1.364l.4,6.269a1.2,1.2,0,0,1-.463,1.024,1.125,1.125,0,0,1-1.08.131l-4.553-1.837v9.41h12.934v-8.221c0-.038.034-.075.037-.114a6.063,6.063,0,0,0-1.5-4.65,6,6,0,0,0-4.42-2.01Zm0,0" transform="translate(-318.013 -118.548)"/><path class="a" d="M395.352,149.211l2.99,1.226-.3-4.629h-.193Zm0,0" transform="translate(-321.244 -118.547)"/><path class="a" d="M26.126,150.679v-5.687a8.631,8.631,0,0,1,1.809-5.29,5.961,5.961,0,0,0-5.975-5.893H17.426l-.647,2.65L18.4,145.42a1.126,1.126,0,0,1-.353,1.035l-3.343,3.023a1.124,1.124,0,0,1-1.534-.023l-3.141-3.023a1.122,1.122,0,0,1-.325-1.021l1.409-8.941c0-.011.006-.018.008-.028l-.642-2.633H5.951a5.944,5.944,0,0,0-5.918,6.568c0,.038.037.075.037.113v10.189Zm0,0" transform="translate(0 -108.797)"/><path class="a" d="M180.992,165.306a6.5,6.5,0,0,0-6.442-6.5H171.7a5.627,5.627,0,0,1-11.081,0h-2.8a6.5,6.5,0,0,0-6.443,6.5v10h29.617Zm0,0" transform="translate(-123 -129.111)"/><path class="a" d="M314.957,160.8h10.872V151.49l-4.226,1.735a1.121,1.121,0,0,1-1.086-.143,1.159,1.159,0,0,1-.464-1.009l.429-6.264h-1.358a6,6,0,0,0-5.648,4.054,8.772,8.772,0,0,1,1.48,4.88Zm0,0" transform="translate(-254.716 -118.548)"/></svg>
            </div>
            <button mat-button [routerLink]="['/dashboard','comite', folio]">Regresar a dashboard</button>
        </div>
    </div>
    <h2>Entrevista</h2>
    <h3>{{ paginas[actual -1].name | uppercase }}</h3> -->

    <div class="body">

        <h3 class="title-section">Información del solicitante</h3>
        <div class="container-form"  *ngIf="actual === 1">
            <div style="flex: 1;">
                <div class="input">
                    <label>Nombre</label>
                    <input matInput  [(ngModel)]="AnalisisPF.solicitante" readonly placeholder="Nombre cliente" type="text">
                </div>

                <div class="input">
                    <label>Fecha</label>
                    <input matInput type="date" [(ngModel)]="AnalisisPF.fecha_creacion" readonly>
                </div>

                <div class="input">
                    <label>Teléfono de casa</label>
                    <input mask="00 0000 0000" matInput [(ngModel)]="AnalisisPF.tel_casa" readonly>
                </div>

                <div class="input">
                    <label>Teléfono de celular</label>
                    <input mask="00 0000 0000" matInput [(ngModel)]="AnalisisPF.tel_cel" readonly>
                </div>

                <div class="input">
                    <label>R.F.C.</label>
                    <input class="uppercase" matInput [(ngModel)]="AnalisisPF.rfc" readonly>
                </div>

                <div class="input">
                    <label>Domicilio particular <span (click)="EditarArrendatario()"><mat-icon>edit</mat-icon></span></label>
                    <textarea matInput [(ngModel)]="AnalisisPF.entrevista_general.domicilio" maxlength="200" rows="5" style="width: 100%; resize: none;" readonly></textarea>
                </div>

               
               
            </div>
            <div style="flex: 1;">
                <div class="input">
                    <label>Monto mensual de la renta</label>
                    <input 
                        (change)="GuardarDatosGeneralesDos()" 
                        mask="separator.2" prefix="$ " thousandSeparator="," matInput  [(ngModel)]="AnalisisPF.entrevista_general.mmr" placeholder="$ 0">
                </div>

                <div class="input">
                    <label>Dependientes económicos</label>
                    <mat-select [(ngModel)]="AnalisisPF.entrevista_general.dependientes">
                        <mat-option value="1">1</mat-option>
                        <mat-option value="2">2</mat-option>
                        <mat-option value="3">3</mat-option>
                        <mat-option value="4">4</mat-option>
                        <mat-option value="5">5</mat-option>
                        <mat-option value="6">6</mat-option>
                    </mat-select>
                </div>

                <div class="input">
                    <label class="editable">Egresos mensules para los dependientes</label>
                    <input matInput [(ngModel)]="AnalisisPF.entrevista_general.emd" mask="separator.2" thousandSeparator="," prefix="$ " placeholder="$ 0">
                    <!-- <mat-error>Campo obligatorio</mat-error> -->
                </div>

                <div class="input">
                    <label class="editable">Gastos en buró</label>
                    <input matInput [(ngModel)]="AnalisisPF.entrevista_general.gastos_buro" mask="separator.2" thousandSeparator="," prefix="$ ">
                    <!-- <mat-error>Campo obligatorio</mat-error> -->
                </div>

                <div class="input" style="height: 48px; display: flex; justify-content: flex-end;">
                    <!-- <label style="display: inline-block; width: 90%!important;"></label> -->
                    <mat-slide-toggle labelPosition="before" [(ngModel)]="AnalisisPF.entrevista_general.consejo_especialidad" (change)="GuardarDatosGeneralesTres()">Consejo de especialidad</mat-slide-toggle>
                    <!-- <mat-select formControlName="consejo_especialidad">
                        <mat-option value="SI">Sí</mat-option>
                        <mat-option value="NO">No</mat-option>
                    </mat-select> -->
                </div>
                <div class="input" style="height: 48px; display: flex; justify-content: flex-end;">
                    <!-- <label style="width: 90%!important; display: inline-block;">Domicilio propio</label> -->
                    <mat-slide-toggle (change)="GuardarDatosGeneralesDos()" labelPosition="before" [(ngModel)]="AnalisisPF.entrevista_general.domicilio_propio" >Domicilio propio</mat-slide-toggle>
                </div>
                <div class="input">
                    <label>Antigüedad (años)</label>
                    <input [specialCharacters]="['space']"
                    [patterns]="customPattern"
                    mask="N{5}" matInput
                    [(ngModel)]="AnalisisPF.entrevista_general.domicilio_antiguedad" 
                    (change)="GuardarDatosGeneralesDos()">
                </div>

            </div>
        </div>
        <h3 class="title-section">Datos actividad económica</h3>
        <div  class="container-form" *ngIf="actual === 1">
            <div style="flex: 1;">
                <div class="input">
                    <label style="display: inline-block; width: 90%;">Sector Público</label>
                    <mat-slide-toggle [(ngModel)]="AnalisisPF.entrevista_economica.sector_publico" ></mat-slide-toggle>
                    <!-- <mat-select >
                        <mat-option [value]="true">Sí</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select> -->
                    <!-- <span class="input-error" *ngIf="submit && !frmActEconomica.controls['sector_publico'].value" >Campo obligatorio</span> -->
                </div>
            
                <div class="input">
                    <label>Hospital / Clínica</label>
                    <input [patterns]="customPattern" mask="E{100}" matInput [(ngModel)]="AnalisisPF.entrevista_economica.hospital_clinica">
                    <!-- <span class="input-error" *ngIf="submit && !frmActEconomica.controls['hospital_clinica'].value" >Campo obligatorio</span> -->
                </div>
            
                <div class="input">
                    <label>Puesto</label>
                    <input [patterns]="customPattern" mask="S{100}" matInput [(ngModel)]="AnalisisPF.entrevista_economica.puesto">
                    <!-- <span class="input-error" *ngIf="submit && !frmActEconomica.controls['puesto'].value" >Campo obligatorio</span> -->
                </div>
            
                <div class="input">
                    <label style="display:inline-block; width: 90%;">Tipo de contrato</label>
                    <mat-radio-group [(ngModel)]="AnalisisPF.entrevista_economica.tipo_contrato">
                        <mat-radio-button value="" labelPosition="before">NA</mat-radio-button>
                        <mat-radio-button value="Base" labelPosition="before">Base</mat-radio-button>
                        <mat-radio-button value="Eventual" labelPosition="before">Eventual</mat-radio-button>
                    </mat-radio-group>
                    <!-- <mat-select>
                        <mat-option value="Base">Base</mat-option>
                        <mat-option value="Eventual">Eventual</mat-option>
                    </mat-select> -->
                    <!-- <span class="input-error" *ngIf="submit && !frmActEconomica.controls['tipo_contrato'].value" >Campo obligatorio</span> -->
                </div>
            </div>
            <div style="flex: 1;">
                <div class="input">
                    <label>Antigüedad</label>
                    <input [specialCharacters]="['space']"
                    [patterns]="customPattern"
                    mask="E{100}" matInput [(ngModel)]="AnalisisPF.entrevista_economica.puesto_antiguedad">
                </div>
                   
                <div class="input">
                    <label>Ingreso neto mensual</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " matInput [(ngModel)]="AnalisisPF.entrevista_economica.ingreso_neto_mensual">
                </div>
            
                <div class="input">
                    <label>Ubicación</label>
                    <textarea matInput [(ngModel)]="AnalisisPF.entrevista_economica.puesto_domicilio" maxlength="200" rows="3"></textarea>
                </div>
            </div>
        </div>

        <h3 class="title-section">Consultorio</h3>

        <div class="container-form" *ngIf="actual == 1">
            <div style="flex: 1;">
            <div><span class="circle">1</span></div><div></div>
            <div>
                <div class="input input-margin-top">
                    <!-- <label style="display: inline-block; width: 90%;">Propio</label> -->
                    <mat-slide-toggle labelPosition="before" [(ngModel)]="AnalisisPF.entrevista_consultorio.propio">¿Propio?</mat-slide-toggle>
                    <!-- <mat-select>
                        <mat-option [value]="true">Sí</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select> -->
                    <!-- <span class="input-error" *ngIf="submit && !frmConsultorio.controls['propio'].value" >Campo obligatorio</span> -->
                </div>
                <div class="input input-margin-top">
                    <label>Antigüedad</label>
                    <input matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.antiguedad">
                </div>
                <div class="input input-margin-top">
                    <label>Monto renta / gastos</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.monto_renta">
                </div>

            </div>
            <div>
                <div class="input">
                    <label>Teléfono</label>
                    <input mask="00 0000 0000" placeholder="( _ _ )" matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.telefono">
                </div>
            
                <div class="input">
                    <label style="display: flex; align-items: center; gap: 8px;">Ubicación del activo <mat-icon (click)="CambiarDireccionActivo()">edit</mat-icon></label>
                    <textarea matInput class="input-textAr" style="border: none !important;" placeholder="Calle, número exterior, interior, Colonia, Delegación o Municipio, Ciudad, Estado, C.P. " [(ngModel)]="AnalisisPF.entrevista_consultorio.domicilio" maxlength="200" rows="3" readonly></textarea>
                </div>
            </div>
            </div>
            <div style="flex: 1;">

            <div class="margin-top-20"><span class="circle">2</span></div><div></div>
            <div style="width: 100%; display: flex; flex-direction: column;">
                <div class="" style="display: flex; justify-content: space-between;">
                    <div style="width: 30%;">
                        <div class="input">
                            <label>No. Pacientes / Mes</label>
                            <input mask="separator.2" thousandSeparator="," matInput #pacientesMes [(ngModel)]="AnalisisPF.entrevista_consultorio.pacientes_por_mes"
                            (input)="CambiarAproximado('ingresos_aprox_pacientes', 'pacientes_por_mes', 'precio_consulta')"
                            >
                        </div>
                    </div>
                    <div style="width: 30%;">
                        <div class="input">
                            <label>Precio de consulta</label>
                            <input mask="separator.2" thousandSeparator="," prefix="$ " matInput #precioConsulta [(ngModel)]="AnalisisPF.entrevista_consultorio.precio_consulta"
                            (input)="CambiarAproximado('ingresos_aprox_pacientes', 'pacientes_por_mes', 'precio_consulta')">
    
                        </div>
                    </div>
                    <div style="width: 30%;">
                        <div class="input">
                            <label style="font-size: 12.5px;">Ingresos aproximados</label>
                            <input mask="separator.2" thousandSeparator="," prefix="$ " #ingresosAproxPacientes readonly
                                matInput 
                                [(ngModel)]="AnalisisPF.entrevista_consultorio.ingresos_aprox_pacientes">
                        </div>
                    </div>
                </div>
                <div class="" style="display: flex; justify-content: space-between;">
                    <div style="width: 30%;">
                        <div class="input">
                            <label>No. Estudios / Mes</label>
                            <input mask="separator.2" thousandSeparator="," matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.estudios_por_mes" #estudiosMes
                            (input)="CambiarAproximado('ingresos_aprox_estudios', 'estudios_por_mes', 'precio_estudio')">
                        </div>
                    </div>
                    <div style="width: 30%;">
                        <div class="input">
                            <label>Precio estudio</label>
                            <input mask="separator.2" thousandSeparator="," prefix="$ " matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.precio_estudio" #precioEstudios
                            (input)="CambiarAproximado('ingresos_aprox_estudios', 'estudios_por_mes', 'precio_estudio')">
                        </div>
                    </div>
                    <div style="width: 30%;">
                        <div class="input">
                            <label>Ingresos aproximados</label>
                            <input mask="separator.2" thousandSeparator="," prefix="$ " #ingresosAproxEstudios readonly
                                matInput
                                [(ngModel)]="AnalisisPF.entrevista_consultorio.ingresos_aprox_estudios">
                        </div>
                    </div>
                </div>

                <div class="" style="display: flex; justify-content: space-between;">
                    <div style="width: 30%;">
                        <div class="input">
                            <label>No. Cirugía / Mes</label>
                            <input mask="separator.2" thousandSeparator="," matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.cirugias_por_mes" #cirugiasMes
                            (input)="CambiarAproximado('ingresos_aprox_cirugias', 'cirugias_por_mes', 'precio_cirugia')">
                        </div>
                    </div>
                    <div style="width: 30%;">
                        <div class="input">
                            <label>Precio de cirugía</label>
                            <input mask="separator.2" thousandSeparator="," prefix="$ " matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.precio_cirugia" #precioCirugias
                            (input)="CambiarAproximado('ingresos_aprox_cirugias', 'cirugias_por_mes', 'precio_cirugia')">
                        </div>
                    </div>
                    <div style="width: 30%;">
                        <div class="input">
                            <label>Ingresos aproximados</label>
                            <input mask="separator.2" thousandSeparator="," prefix="$ " #ingresosAproxCirugias readonly
                                matInput
                                [(ngModel)]="AnalisisPF.entrevista_consultorio.ingresos_aprox_cirugias">
                        </div>
                    </div>
                </div>
                <div class="row" style="display: flex; justify-content: space-between;">
                    <div style="width: 30%;">
                        <div class="input" style="flex-direction: column;">
                            <label style="display: block; width: 100%;">Ingresos en efectivo</label>
                            <input mask="separator.2" thousandSeparator="," prefix="$ " matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.ingresos_efectivo" #ingresosEfectivo>
                        </div>
                    </div>
                </div>
            </div>
            </div>
         </div>
         <div class="container-form">
            <div style="width: 18%; flex: 1; align-items: center; display: flex;">
                <div style="width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                    <label style="width: 100%; text-align: center; margin-top: 20px;">Ingresos mensuales aproximados</label>
                            <input
                                class="input-ingresos"
                                mask="separator.2"
                                thousandSeparator=","
                                prefix="$ "
                                matInput
                                readonly
                                [(ngModel)]="AnalisisPF.entrevista_consultorio.ingresos_aprox_mensuales">
                        </div>
            </div>
            <div style="flex: 1;">
            <div><span class="circle">3</span></div><div></div>

            <div>
                <!-- <div class="input" style="flex-direction: column;">
                    <label style="display: block; width: 100%;">Ingresos en efectivo</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " matInput formControlName="ingresos_efectivo" #ingresosEfectivo>
                </div> -->
            </div><div></div>


            <div>
                <div class="input">
                    <label style="display: block; width: 100%;">Tipo de equipo</label>
                    <mat-radio-group [(ngModel)]="AnalisisPF.entrevista_consultorio.tipo_equipo" style="width: 100%;">
                        <mat-radio-button labelPosition="before" value="Nuevo">Nuevo</mat-radio-button>
                        <mat-radio-button labelPosition="before" value="Renovacion">Renovación</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div><div></div>

            <div style="width: 70%;">
                <div class="" style="width: 100%;">
                    <div class="input" style="width: 100%;">
                        <label>Tipo de estudios</label>
                        <input matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.tipo_estudios" [patterns]="customPattern" mask="S{100}">
                    </div><br>
                    <div></div>
                </div>
                <div class="" style="width: 100%;">
                    <div style="width: 100%; display: flex; justify-content: space-between;">
                        <div style="width: 30%;">
                            <div class="input">
                                <label>No. Estudios / Mes</label>
                                <input mask="0{10}" matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.estudios_por_mes_equipo" #estudiosMesEquipo
                                (input)="CambiarAproximado('ingresos_aprox_estudios_equipo', 'estudios_por_mes_equipo', 'precio_estudio_equipo')">
                            </div>
                        </div>
                        <div style="width: 30%;">
                            <div class="input">
                                <label>Precio de estudios</label>
                                <input mask="separator.2" thousandSeparator="," prefix="$ " matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.precio_estudio_equipo" #precioEstudioEquipo
                                (input)="CambiarAproximado('ingresos_aprox_estudios_equipo', 'estudios_por_mes_equipo', 'precio_estudio_equipo')">
                            </div>
                        </div>
                        <div style="width: 30%;">
                            <div class="input">
                                <label>Ingresos aproximados</label>
                                <input 
                                    mask="separator.2"
                                    thousandSeparator=","
                                    prefix="$ "
                                    matInput readonly
                                    [(ngModel)]="AnalisisPF.entrevista_consultorio.ingresos_aprox_estudios_equipo">
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>

            </div>
            <div>
                <div class="input">
                <label>Ingresos extras con equipo nuevo</label>
                    <input mask="separator.2" thousandSeparator="," prefix="$ " matInput [(ngModel)]="AnalisisPF.entrevista_consultorio.ingresos_extras_equipo">
                </div>
            </div><div></div>
            </div>
         </div>

        <h3 class="title-section">Aval</h3>

        <div class="container-form" *ngIf="actual === 1">
            <div style="flex: 1;">
                <div class="input">
                    <label>Nombre</label>
                    <input matInput [(ngModel)]="AnalisisPF.aval.aval_nombre" maxlength="100" >
                </div>

                <div class="input">
                    <label>Ocupación</label>
                    <input [specialCharacters]="['space']" [patterns]="customPattern" mask="S{100}" matInput [(ngModel)]="AnalisisPF.aval.aval_ocupacion" maxlength="100">
                </div>

                <div class="input">
                    <label>Tiempo de conocerlo</label>
                    <input [specialCharacters]="['space']"
                    [patterns]="customPattern"
                    mask="E{100}" matInput [(ngModel)]="AnalisisPF.aval.tiempo_conocerlo" >
                </div>
            
                <div class="input">
                    <!-- <label style="display: inline-block; width: 90%;"></label> -->
                    <mat-slide-toggle labelPosition="before" [(ngModel)]="AnalisisPF.aval.lo_recomienda">Lo recomienda</mat-slide-toggle>
                    <!-- <mat-select formControlName="lo_recomienda">
                        <mat-option value="SI">Sí</mat-option>
                        <mat-option value="NO">No</mat-option>
                    </mat-select> -->
                </div>
            </div>
            <div style="flex: 1;">
                <div class="input">
                    <label>Parentezco</label>
                    <input [specialCharacters]="['space']" [patterns]="customPattern" mask="S{100}" matInput [(ngModel)]="AnalisisPF.aval.aval_parentezco" maxlength="100">
                </div>
            
                <div class="input">
                    <label>Teléfono</label>
                    <input mask="00 0000 0000" placeholder="( _ _ )" matInput [(ngModel)]="AnalisisPF.aval.aval_telefono">
                </div>

                <div class="input">
                    <label>Dirección <span (click)="EditarArrendatario(true)"><mat-icon>edit</mat-icon></span></label>
                    <textarea matInput placeholder="Calle, número exterior, interior, Colonia, Delegación o Municipio, Ciudad, Estado, C.P. " [(ngModel)]="AnalisisPF.aval.aval_domicilio" rows="4" readonly></textarea>
                </div>
            </div>
        </div>

        <h3 class="title-section">Referencias</h3>
        <div class="container-form"  *ngIf="actual === 1">
            <div *ngFor="let ref of AnalisisPF.referencias; let i = index" style="flex: 1;">
                <div class="title">Referencia {{i +1}}</div>
                <div class="input">
                    <label>Nombre</label>
                    <input [patterns]="customPattern" mask="S{100}" matInput [(ngModel)]="ref.nombre" maxlength="100" placeholder="Nombre de referencia">
                    <!-- <span class="input-error" *ngIf="submit">Campo obligatorio</span> -->
                </div>
            
                <div class="input">
                    <label>Ocupación</label>
                    <input [patterns]="customPattern" mask="S{100}" matInput [(ngModel)]="ref.ocupacion" maxlength="100">
                    <!-- <span class="input-error" *ngIf="submit">Campo obligatorio</span> -->
                </div>
            
                <div class="input">
                    <label>Dirección</label>
                    <textarea style="height: 40px!important;" [(ngModel)]="ref.domicilio" maxlength="100" placeholder="Calle, número exterior, interior, colonia, delegación o municipio, ciudad o población, Estado, C.P."></textarea>
                    <!-- <input matInput [(ngModel)]="ref.domicilio && !ref.domicilio" maxlength="100"> -->
                    <!-- <span class="input-error" *ngIf="submit">Campo obligatorio</span> -->
                </div>
            
                <div class="input">
                    <label>Teléfono</label>
                    <input mask="00 0000 0000" plecaholder="( _ _ )" matInput [(ngModel)]="ref.telefono">
                    <!-- <span class="input-error" *ngIf="submit">Campo obligatorio</span> -->
                </div>
            
                <div class="input">
                    <label>Tiempo de conocerlo</label>
                    <input [specialCharacters]="['space']"
                    [patterns]="customPattern"
                    mask="E{100}" matInput [(ngModel)]="ref.tiempo_conocerlo">
                    <!-- <span class="input-error" *ngIf="submit">Campo obligatorio</span> -->
                </div>
            
                <div class="input">
                    <label>Parentesco</label>
                    <input [patterns]="customPattern" mask="S{100}" matInput [(ngModel)]="ref.parentezco" maxlength="100">
                    <!-- <span class="input-error" *ngIf="submit">Campo obligatorio</span> -->
                </div>

                <div class="input">
                    <!-- <label style="display: inline-block; width: 90%;"></label> -->
                    <mat-slide-toggle labelPosition="before" 
                    [ngModel]="getLoRecomienda(ref, i)"
                    (ngModelChange)="setLoRecomienda(ref, i, $event)">Lo recomienda</mat-slide-toggle>
                    <!-- <mat-select [(ngModel)]="ref.lo_recomienda">
                        <mat-option value="SI">Sí</mat-option>
                        <mat-option value="NO">No</mat-option>
                    </mat-select> -->
                    <!-- <span class="input-error" *ngIf="submit">Campo obligatorio</span> -->
                </div>
            
            </div>
        </div>
        <button class="next-button" mat-button (click)="NextPage()" matStepperNext>
            Guardar
            <!-- <mat-icon>navigate_next</mat-icon> -->
            <svg style="height: 20px; width:auto;"  xmlns="http://www.w3.org/2000/svg" width="31.25" height="31.25" viewBox="0 0 31.25 31.25"><defs><style>.next{fill:#00a5da;}</style></defs><path class="next" d="M15.625,0A15.625,15.625,0,1,0,31.25,15.625,15.626,15.626,0,0,0,15.625,0Zm-1.3,24.74V12.173L8.755,17.741l-2.21-2.21,9.079-9.081,9.081,9.081-2.21,2.21-5.569-5.568V24.74Z" transform="translate(31.25) rotate(90)"/></svg>
        </button>
    </div>

    <app-socials-footer style="width: 100%;"></app-socials-footer>
</div>